import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2, ImageAdd, Trash2 } from 'blaze-ui/icons'
import Styles from './SectionsSelection.module.scss'
import { NewsletterSection } from './Types'
import { useSections } from './SectionsProvider'
import { Text } from 'blaze-ui/Text/Text'
import { Input } from 'almanac-ui/TextInputField/Input'
import { ImageIcons } from './ImageIcons'
import { SelectImageButton } from './SelectImageButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useFormikContext } from 'formik'
import cx from 'classnames'
import { MediaFileViewerModal } from 'components/MediaFileViewerModal/MediaFileViewerModal'
import { useModals } from 'almanac-ui/Modal'
import { MediaObject } from 'types'

export interface Props {
  section: NewsletterSection
  index: number
}

export const Section = ({ section, index }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { updateSection, removeSection, removeImage, sections } = useSections()
  const { errors } = useFormikContext()
  const { openModal } = useModals()

  const isValid = !(errors as any).section_titles?.find((title: string) =>
    title?.includes(`section_titles["${index}"]`),
  )

  return (
    <div className={Styles.content}>
      <div className={Styles.data}>
        <div className={Styles.header}>
          <div className={Styles.top}>
            <Text variant={isMobile ? 'metadata' : 'secondary'} color={isMobile ? 'var(--dark-60)' : 'var(--dark-40)'}>
              Section Title #{index + 1}
            </Text>
            {sections.length > 1 && (
              <Button variant="ghost" size="xs" frontIcon={Trash2} onPress={() => removeSection(section)}>
                Remove Section
              </Button>
            )}
          </div>

          <Input
            scrollable={false}
            size={isMobile ? 'sm' : 'lg'}
            name={`Section Title ${index + 1}`}
            isTextarea={isMobile}
            value={section.title}
            onChange={(e) => updateSection({ ...section, title: e.target.value })}
            aria-label="Generated Subject Line"
            placeholder="Write your own section title..."
            isValid={isValid}
          />
        </div>
        <div className={cx(Styles.imageContainer, { [Styles.isEmpty]: !section.imageUrl })}>
          {section.imageUrl ? (
            <img
              src={section.imageUrl}
              alt={`section ${index}`}
              onClick={() =>
                openModal(
                  MediaFileViewerModal,
                  {
                    file: { id: 1, source_url: section.imageUrl, mime_type: 'image/jpeg', position: 0 } as MediaObject,
                    editEnabled: false,
                    showTitle: false,
                  },
                  { newStack: true },
                )
              }
              className={Styles.image}
            />
          ) : (
            <div className={Styles.imageEmptyState}>
              <ImageIcons />
              <Text variant="metadata" color="var(--dark-80)">
                Make your newsletter more engaging by adding an image
              </Text>
              <SelectImageButton section={section} label="Add Image" frontIcon={ImageAdd} />
            </div>
          )}
          {section.imageUrl && (
            <div className={Styles.imageActions}>
              <div className={Styles.imageActionContainer}>
                <SelectImageButton section={section} frontIcon={ArrowRefresh2} label="Change" />
              </div>
              <div className={Styles.imageActionContainer}>
                <Button
                  variant="secondary"
                  frontIcon={Trash2}
                  size={isMobile ? 'sm' : 'md'}
                  onPress={() => removeImage(section)}
                >
                  Remove
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
